var _path, _path2, _path3, _path4, _path5, _path6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 512,
    height: 512,
    viewBox: "0 0 512 512",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M512 256C512 114.615 386.677 22.7554 358.4 22.7554C386.677 22.7554 399.6 127.182 399.6 256C399.6 384.817 386.677 489.244 358.4 489.244C386.677 489.244 512 397.385 512 256Z",
    fill: "#6C62F3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 256C0 114.615 125.323 22.7554 153.6 22.7554C125.323 22.7554 112.4 127.182 112.4 256C112.4 384.817 125.323 489.244 153.6 489.244C125.323 489.244 0 397.385 0 256Z",
    fill: "#FEBD46"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M256.001 0C284.278 0 307.201 114.615 307.201 256C307.201 397.385 284.278 512 256.001 512C227.724 512 204.801 397.385 204.801 256C204.801 114.615 227.724 0 256.001 0Z",
    fill: "#E3676C"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M153.6 22.7554C181.877 22.7554 204.8 127.182 204.8 256C204.8 384.817 181.877 489.244 153.6 489.244C125.323 489.244 102.4 384.817 102.4 256C102.4 127.182 125.323 22.7554 153.6 22.7554Z",
    fill: "#FD9C57"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M358.399 22.7554C386.676 22.7554 409.599 127.182 409.599 256C409.599 384.817 386.676 489.244 358.399 489.244C330.122 489.244 307.199 384.817 307.199 256C307.199 127.182 330.122 22.7554 358.399 22.7554Z",
    fill: "#6C62F3"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M358.399 22.7554C386.676 22.7554 409.599 127.182 409.599 256C409.599 384.817 386.676 489.244 358.399 489.244C330.122 489.244 307.199 384.817 307.199 256C307.199 127.182 330.122 22.7554 358.399 22.7554Z",
    fill: "black",
    fillOpacity: 0.3
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.5059e86d4cc0f9193cab752b3dc1232a.svg";
export { ForwardRef as ReactComponent };